<template>
	<div class="detail">

		<!-- 导航栏 -->
		<tabbar :show="show">
			<div slot="title" class="title">
				<van-tabs v-model="active" van-tabs @click="goDetail">
					<!--<van-tab title="商品">商品</van-tab>-->
					<van-tab title="科普技术">科普技术</van-tab>
					<!--<van-tab title="详情">详情</van-tab>-->
				</van-tabs>
			</div>
		</tabbar>
		<!-- 吸底按钮 -->
		<div class="btn">
			<!--<div class="customer text_size16 text_colorfff bg_color0" @click="customer" style="width: 100%;">咨询客服</div>-->
			<!--原<div class="buy text_size16 text_colorfff bg_color3" @click="buy">立即购买</div>-->
			<div class="customer text_size16 text_colorfff bg_color0" @click="customer" style="width: 100%;">咨询客服</div>
		</div>
		<!-- 填充 -->

		<div class="none"></div>
		<!-- 图 -->
		<div class="imgs">
			<van-swipe   :initial-swipe="1">
				<van-swipe-item v-for="(item, index) in goodsDetail.goodImages" :key="index">					
					<!--<video  id="myVideo" controls="controls" bindpause="handleStop" poster="http://www.hscmo.com/statics/images/videoNew63s.png" v-if="item.endsWith('mp4')" width="100%" class="video-js vjs-big-play-centered vjs-fluid  vjs-default-skin" >
						<source type="video/mp4" :src="item" ></source>
				</video>
					<img :src="item" style="transform: translateY(1px)" v-else/>-->
					<img :src="item" style="transform: translateY(0px)"/>
					<!--<video  src="item" controls="controls" bindpause="handleStop" poster="" v-if></video>
                    <img :src="item" style="transform: translateY(1px)"/>-->
				</van-swipe-item>
			</van-swipe>
		</div>

		<!--头部活动图-->
		<div class="setbannerShow" v-if="goodsDetail.isActive==1">
			<div class="setbanner" @click="goDetailBan">
				<img :src="querySet.topBannerUrl">
			</div>
		</div>
		<!-- 文 
		<div class="text">
			<h3 v-text="goodsDetail.goodsName" class="text_size16 text_color000"></h3>
			<div class="price text_color0 text_size24"><i class="text_color0 text_size13">￥</i>{{goodsDetail.channelPriceStr}}</div>
			<div class="desc">
				<p v-text="goodsDetail.activeDesc" class="text_color666 text_size12 activeFont"></p>
				<p v-text="goodsDetail.goodsDesc" class="text_color666 text_size12"></p>
				<p v-text="'推荐人群：' + goodsDetail.forPeople || ''" class="text_color666 text_size12" style="margin-top: 8px;"></p>
			</div>

		</div>-->

		<!--活动产品-->
		<div class="setbannerShow" v-if="goodsDetail.isActive==1">
			<div class="activity_box">
				<div class="activity_text">
					<img :src="$store.state.api.imgUrl + 'act_08.jpg'" alt="">
				</div>
				<div class="activity_goodsTop">
					<img :src="$store.state.api.imgUrl + 'act_01.jpg'" alt="">
				</div>
				<div class="activity_goodsFirst">
					<a href="http://www.pantaoys.com/h5/index?goodsId=ZAgLHeJr608&channelId=9acVBaHt718&target=detail"><img :src="$store.state.api.imgUrl + 'act_02.jpg'" alt="HIV DNA 定量检测"></a>
				</div>
				<div class="activity_goodsList">
					<a href="http://www.pantaoys.com/h5/index?goodsId=oogFSdX7464&channelId=9acVBaHt718&target=detail"><img :src="$store.state.api.imgUrl + 'act_03.jpg'" alt="单次检测"></a>
					<a href="http://www.pantaoys.com/h5/index?goodsId=zILXtprX847&channelId=9acVBaHt718&target=detail"><img :src="$store.state.api.imgUrl + 'act_04.jpg'" alt="两次检测"></a>
					<a href="http://www.pantaoys.com/h5/index?goodsId=W3590CIx344&channelId=9acVBaHt718&target=detail"><img :src="$store.state.api.imgUrl + 'act_05.jpg'" alt="情侣检测"></a>
				</div>
				<div class="activity_text">
					<img :src="$store.state.api.imgUrl + 'act_06.jpg'" alt="">
				</div>
				<div class="activity_kefu" @click="customer">
					<img :src="$store.state.api.imgUrl + 'act_07.jpg'" alt="">
				</div>
			</div>
		</div>

		<div class="bot" v-html="goodsDetail.goodsDetail"></div>
		<!-- 推荐 
		<div :class="{pro: recommendGoods.length > 0, none2: recommendGoods.length == 0, none4: recommendGoods.length == 0}">
			<h3 class="text_size12 text_color0"><i></i> 相关推荐</h3>
			<div class="recommendGoods">
				<div v-for="(item,idx) in recommendGoods" :key="idx" @click="goGoodsId(item.goodsId)" :data-goodsId="item.goodsId">
					<img :src="item.goodImages[0]" alt="" :data-goodsId="item.goodsId">
					<p v-text="item.goodsName" class="text_size12 text_color666" :data-goodsId="item.goodsId"></p>
				</div>
			</div>
			<div v-if="recommendGoods.length > 0" class="none3 none2">1</div>
		</div>-->
	</div>
</template>
<script>
	import './detail.scss';
	import qs from 'qs';
	import api from '@/utils/js/api.js';
	
	export default {
		data() {
			return {
				active: 0,
				// current:'',
				querySet: {},
				goodsId: '',
				goodsDetail: '',
				//recommendGoods: '',
				goodsDetail2: '',
				query: '',
				show: 0,
				userInfo: '',
				token: ''
			}
		},
		created() {
			console.log('query', this.$route);
			if(this.$route.query.channelId) {
				this.$store.commit({
					type: 'comment',
					name: 'channelId',
					channelId: this.$route.query.channelId
				})
			}
			if(this.$route.query.code && localStorage.getItem('get_openid')) {
				localStorage.removeItem('get_openid');
				this.wechat_code(this.$route.query.code)
			}
			if(this.$store.state.is_wx) this.show = 1;
			this.userInfo = this.$store.state.userInfo;
			this.token = this.$store.state.token;
			this.query = this.$route.query;
			this.goodsId = this.$store.state.goodsId || this.query.goodsId;
			this.getGoodsDetail();
			this.getSetpic()
		},
		beforeMount() {
			if(this.$route.query.target) {
				this.$store.commit({
					type: 'comment',
					name: 'is_target',
					is_target: this.$route.query.target
				})
			}
		},
		methods: {
			//顶部banner
			getSetpic() {
				this.$http({
					url: api.querySet,
					method: 'post',
					data: {
						topBannerUrl: this.topBannerUrl,
						setStatus: 1
					}
				}).then(res => {
					console.log('querySet', res);
					if(res.success) {
						this.querySet = res.data;
					} else {
						this.$toast(res.message);
					}
				})
			},

			// 商品详情
			getGoodsDetail() {
				this.$http({
					url: api.goodsDetail,
					method: 'post',
					data: {
						goodsId: this.goodsId,
						channelId: this.$store.state.channelId
					}
				}).then(res => {
					console.log('goodsDetail', res);
					if(res.success) {
						this.goodsDetail = res.data;
						this.$store.commit({
							type: 'comment',
							name: 'curGoods',
							curGoods: this.goodsDetail
						})
						//this.getRecommendGoods();
					} else {
						this.$toast(res.message);
					}
				})
			},
			// 商品推荐
			/*getRecommendGoods() {
				this.$http({
					url: api.recommendGoods,
					method: 'post',
					data: {
						goodsId: this.goodsId,
						channelId: this.$store.state.channelId,
						goodsClassId: this.goodsDetail.goodsClassId
					}
				}).then(res => {
					console.log('recommendGoods', res);
					if(res.success) {
						this.recommendGoods = res.data;
					} else {
						this.$toast(res.message);
					}
				}).catch(error => {
					console.log('recommendGoods', error);
				})
			},*/
			// 详情tab跳转
			goDetail(idx, $event) {
				if(idx == 0) {
					this.$el.querySelector('.none').scrollIntoView();
				} else {
					this.$el.querySelector('.none2').scrollIntoView();
				}
			},
			//商品推荐点击
			goGoodsId(_goodsId) {
				console.log('goGoodsId', _goodsId);
				this.goodsId = _goodsId;
				this.$store.commit({
					type: 'eachComment',
					data: [{
							name: 'goodsId',
							goodsId: _goodsId
						},
						{
							name: 'key',
							key: new Date().toString()
						}
					]
				})
				this.$el.querySelector('.none').scrollIntoView();
			},
			// 客服
			customer() {
				this.$router.push({
					name: 'service',
				})
			},
			//微信授权取code
			wechat() {
				var data = {
					appid: 'wxe6d64706308fd8b3',
					// redirect_uri: encodeURI('http://www.pantaoys.com/h5/login'),
					redirect_uri: encodeURI(window.location.href),
					response_type: 'code',
					scope: 'snsapi_userinfo',
					state: (new Date()).valueOf(),
				}
				localStorage.setItem('get_openid', '1');
				location.href = api.wechat_auth + `?${qs.stringify(data)}#wechat_redirect`;
			},
			// 微信登录公众号
			wechat_code(_code) {
				this.$http({
					url: api.weChatOpenAccountLogin,
					method: 'post',
					data: {
						code: _code,
						channelId: this.$store.state.channelId
					}
				}).then(res => {
					console.log('weChatOpenAccountLogin', res)
					if(res.success) {
						localStorage.setItem('token', res.data.token);
						localStorage.setItem('userInfo', JSON.stringify(res.data));
						// this.login_text = "绑定手机"
						this.save_userInfo(true)
					} else {
						this.$toast(res.message);
					}

				})
			},
			// 保存更新userInfo
			save_userInfo() {
				this.token = localStorage.getItem('token');
				this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || '';
				if(this.token && this.userInfo) {
					this.$store.commit({
						type: 'getUserInfo',
						must: true
					})
					this.buy();
				}
			},
			// 立即购买
			buy() {
				//判断是否登录
				if(!this.userInfo || !this.token) return this.wechat();
				this.$store.commit({
					type: 'comment',
					name: 'goodsId',
					'goodsId': this.goodsId
				})
				this.$router.push({
					name: 'sure_order',
					query: {
						goodsId: this.goodsId
					}
				})
			},

			//学术文章跳转
			goDetailBan() {
				this.$router.push({
					name: 'activity',
				})
			}
	       

		},
	}
</script>